import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from "./Login.module.css";
import api from '../../services/api';
import { toast } from 'react-toastify';
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import logoInteagro from "../../assets/img/logo-inteagro.png";

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isVisible, setIsVisible] = useState(false);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const response = await api.post('/auth/login', { email, password });
      const { token, user } = response.data.data;

      // Salva tudo no localStorage
      localStorage.setItem("inteagro_token", token);
      localStorage.setItem("nome", user.nome);
      localStorage.setItem("role", user.perfil);
      localStorage.setItem("modulo", user.modulo || "agro");
      localStorage.setItem("uid_unidade_producao", user.uid_unidade_producao || "");
      localStorage.setItem("uid_projeto", user.uid_projeto || "");
      localStorage.setItem("uid_estabelecimento", user.uid_estabelecimento || "");

      toast.success("Login efetuado com sucesso!");

      // Redireciona para o módulo correto
      setTimeout(() => {
        if (user.modulo === "pesca" || user.modulo === "admin") {
          navigate('/admin');
        } else {
          navigate('/agro/dashboard');
        }
      }, 800);
    } catch (error: any) {
      toast.error(error.response?.data?.message || "E-mail ou senha inválidos.");
    }
  };

  return (
    <div className={styles.main}>
      <div className={`${styles.contentLeftSide} desktop`}>
        <h1 className={styles.title}>
          <span className={styles.textGradientAnimated}>Inteagro</span>{" "}
          Conectando o campo ao futuro.
        </h1>
      </div>

      <form onSubmit={handleLogin} className={styles.containerLogin}>
        <div className={styles.login}>
          <div className={styles.loginHead}>
            <img src={logoInteagro} alt="Inteagro" className={styles.logoLogin} />
          </div>

          <div className={styles.loginInputs}>
            <label htmlFor="email">E-mail</label>
            <input
              type="email"
              placeholder="Digite seu e-mail"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className={styles.loginInputs}>
            <label htmlFor="password">Senha</label>
            <div style={{ position: 'relative' }}>
              <input
                type={isVisible ? "text" : "password"}
                placeholder="Digite sua senha"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <button
                type="button"
                className={styles.eyeButton}
                onClick={() => setIsVisible(!isVisible)}
              >
                {isVisible ? <VisibilityIcon /> : <VisibilityOffIcon />}
              </button>
            </div>
          </div>

          <div className={styles.loginButtons}>
            <button type="submit" className={styles.submitBtn}>Entrar</button>
            <button type="button" className={styles.forgotBtn}>Restaurar minha senha</button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default Login;
